import { SVGProps } from "react";

const UploadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.83301 11.6663L9.16634 8.33301M9.16634 8.33301L12.4997 11.6663M9.16634 8.33301V15.833M15.833 12.2854C16.8509 11.4447 17.4997 10.173 17.4997 8.74967C17.4997 6.21837 15.4476 4.16634 12.9163 4.16634C12.7342 4.16634 12.5639 4.07134 12.4714 3.91446C11.3847 2.07037 9.37837 0.833008 7.08301 0.833008C3.63123 0.833008 0.833008 3.63123 0.833008 7.08301C0.833008 8.80476 1.52921 10.3639 2.65547 11.4943"
      stroke="#6B7280"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UploadIcon;

